/* eslint-disable indent */
export const taxTypes = [
    { label: 'Excise Tax', value: 'excise_tax' },
    { label: 'State tax', value: 'state_tax' },
    { label: 'County tax', value: 'county_tax' },
    { label: 'City Tax', value: 'city_tax' }
  ]